import { render, staticRenderFns } from "./ViewBulkTransferInDetails.vue?vue&type=template&id=bc2cfbc8&"
import script from "./ViewBulkTransferInDetails.vue?vue&type=script&lang=js&"
export * from "./ViewBulkTransferInDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports